<template>
<div class="calendar-filter">
    <div class="calendar-filter__container">
        <z-tabs only-visual @toggle-item="onTabChange($event)">
            <template v-slot:label>
                <z-tabs-label
                    v-for="type in types"
                    :key="type.id"
                    :id="type.id"
                    :initial-state="type.selected"
                >{{type.text}}</z-tabs-label>
            </template>
        </z-tabs>

        <z-date-picker
            v-show="params.type === 'past'"
            class="calendar-filter__datepicker"
            v-model="params.date"
            :placeholder="text.datePlaceholder"
            range
        />
    </div>
</div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'calendar-filter',
    props: {
        showPast: {
            type: Boolean,
            default: false
        },
        initial: {
            type: Object
        }
    },
    data () {
        return {
            types: [
                {
                    'id': 'upcoming',
                    'selected': false,
                    'disabled': false,
                    'text': localize({
                        ru: 'Предстоящие',
                        en: 'Upcoming'
                    }),
                    'xmlId': 'upcoming'
                },
                {
                    'id': 'past',
                    'selected': false,
                    'disabled': false,
                    'text': localize({
                        ru: 'Архив',
                        en: 'Archive'
                    }),
                    'xmlId': 'past'
                }
            ],
            text: {
                datePlaceholder: localize({
                    ru: 'Выберите дату',
                    en: 'Select a date'
                })
            },
            params: {
                date: '',
                type: ''
            }
        }
    },
    methods: {
        onTabChange (tab) {
            const type = tab.replace('tabs-', '')
            this.types.forEach(obj => {
                if (obj.id === type) {
                    obj.selected = true
                } else {
                    obj.selected = false
                }
            })

            this.params.type = type
            this.params.date = ['', '']
        },

        send () {
            this.$emit('change', this.params)
        }
    },
    watch: {
        params: {
            handler () {
                this.send()
            },
            deep: true
        }
    },
    created () {
        const {from, to, ...initial} = this.initial
        initial.date = [from, to]
        this.params = {...this.params, ...initial}
        this.types.forEach(el => {
            if (el.id === initial.type) el.selected = true
        })
    }
}
</script>

<style lang="scss">
.calendar-filter {
    &__container {
        display: flex;
        justify-content: space-between;

        @include breakpoint (v-tablet) {
            display: block;
        }
    }

    &__datepicker {
        width: 400px;
        max-width: 100%;

        @include breakpoint (v-tablet) {
            margin-top: $token-spacers-s;
        }
    }
}
</style>
